<template>
  <div>
    <div style="background: white; padding-bottom: 16px; margin-top: 20px">
      <div class="itemCarNo">{{ carNo }}</div>
      <div class="deliver"></div>
      <div class="itemContainRow">
        <span>{{$t('time.startTimeHolder')}}：</span><span>{{ beginTime }}</span>
      </div>
      <div class="itemContainRow">
        <span>{{$t('time.endTimeHolder')}}：</span><span>{{ endTime }}</span>
      </div>
      <div class="itemContainRow">
        <span>{{$t('fuelEfficientDriving.持续时长')}}：</span><span>{{ duration }}</span>
      </div>
      <div class="itemContainRow">
        <span>{{$t('行程统计.发生位置')}}：</span><span>{{ position }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    beginTime: {
      type: String,
      default: "",
    },
    endTime: {
      type: String,
      default: "",
    },
    duration: {
      type: String,
      default: "",
    },
    position: {
      type: String,
      default: "",
    },
    carNo: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>
<style scoped lang="scss">
.itemCarNo {
  height: 44px;
  align-items: center;
  display: flex;
  padding-left: 16px;
  font-weight: 600;
  font-size: 16px;
  color: #333333;
}
.deliver {
  height: 1px;
  background: #d8d8d8;
  margin: 0px 16px;
}
.itemContainRow {
  margin-top: 12px;
  text-align: left;
  padding: 0px 16px;
  display: flex;
}
.itemContainRow > span {
  font-weight: 400;
  font-size: 14px;
}
/* 第一个 span（标签） */
.itemContainRow span:first-child {
  color: #999999;
}

/* 第二个 span（值） */
.itemContainRow span:nth-child(2) {
  color: #444444;
  flex: 1;
  line-height: 18px;
}
</style>